import React from 'react';
import './App.css';
import MainView from './views/MainView';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <MainView />
      </header>
    </div>
  );
}

export default App;
